<article class="container section-inset-y my-2">
  <app-faq-section [title]="block()?.title" [group]="faqArray$()" [cookiePreferences]="cookies() || undefined"></app-faq-section>
</article>
